const TrendingTextLoading = () => {
  return (
    <div className="loading my-2 h-6 w-full rounded-md bg-border-light dark:bg-border" />
  );
};

export default TrendingTextLoading;
